import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

import { Input } from 'components/Input';
import { RegisterType } from 'types';
import { Button } from 'components/Button';

export const useColumns = (register: RegisterType) =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Discounts',
        columns: [
          {
            Header: 'Amount',
            accessor: 'amount',
            Cell: () => <Input register={register} motive="m4" name="amount" />,
          },
          {
            Header: 'Discount',
            accessor: 'discount',
            Cell: () => <Input register={register} motive="m4" name="discount" />,
          },
          {
            accessor: 'id',
            Cell: () => <Button iconLeft="FiX" motive="delete" />,
          },
        ],
      },
    ],
    []
  );
